// extracted by mini-css-extract-plugin
export default {"drink_title":"RecipeHeader_drink_title__9oDBE","recipe_header":"RecipeHeader_recipe_header__j0vV1"};